
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../util';
import { TreeNode } from './account.service';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

declare var window: WindowType;

export class AccountSelect {
  parentList: TreeNode[] = [];
  selectedItem: number | undefined;
}

@Component({
  name: 'accountSelectComponent',
  components: {
    vSelect
  },
})

export default class AcccountSelectComponent extends Vue {
  private vm: AccountSelect = new AccountSelect();
  private isReady: boolean = false;
  private isRefresh: boolean = false;

  mounted() {
    this.isReady = false;
    // wait until page is ready !
    window.addEventListener('load', () => {  // run after everything is in-place
      this.fetchModel();
      if (window.application.isRefresh != undefined)
        this.isRefresh = Boolean(window.application.isRefresh);
        console.log('window_--->' + this.isRefresh);
    });
  }

  updated() {
    this.isReady = true;  // block change early change events
  }

  fetchModel() {
    this.getAccountSelect().then(data => {
      console.log(data);
      this.vm = data as AccountSelect;
      console.log(this.vm);
      console.log(this.vm.parentList);
    });
  }


  getAccountSelect(): Promise<AccountSelect> {
    console.log('getAccountSelect');
    return fetch('manager/api/account/getAccountSelect')
        .then(response => {
          return response.json() as Promise<AccountSelect>;
        });
  }

  postChange() {
    console.log('postchange');
    if (this.isReady === true) {
      console.log(this.vm);
      this.saveAccountSelect(this.vm)
          .then(data => {
            console.log('Add ok');
            console.log(data);
            if (this.isRefresh) {
              window.location.reload();
            }
          });
    }
  }

  saveAccountSelect(vm: AccountSelect): Promise<any> {
    console.debug('saveAccountSelect');
    return fetch('manager/api/account/SaveAccountSelect',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(vm),
        });
  }

  get selectOptions() {
    return this.vm.parentList.map(item => ({
      label: `${item.text} - ${item.path}`, // What the user sees
      value: item.dbId // The actual ID
    }));
  }

  onValueChange(value: number | null) {
    // value will be the dbId because of the :reduce property
    console.log("Selected ID:", value);
    this.vm.selectedItem = value || undefined;
    if (value !== null) {
      this.postChange();
    }
  }
}
